import { render } from "./networkError.vue?vue&type=template&id=06f6f80d&scoped=true"
import script from "./networkError.vue?vue&type=script&lang=js"
export * from "./networkError.vue?vue&type=script&lang=js"

import "./networkError.vue?vue&type=style&index=0&id=06f6f80d&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f6f80d"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
